import HeartSolidSVG from '../../assets/svg/heart-solid.svg';
export default HeartSolidSVG;
